import { Box } from '@mui/material';
import { ElementType } from 'react';
import type { StatusColor } from '../../../../../themes/v2/theme';
import Icon from '../../Icon/Icon';

interface StatusIconProps {
  icon: ElementType;
  color: StatusColor;
  size?: 'small' | 'medium';
  className?: string;
}

const StatusIcon = ({ icon, color, size = 'medium', className }: StatusIconProps) => (
  <Box
    component="span"
    className={className}
    sx={(theme) => ({ display: 'inline-flex', color: theme.palette.custom.status[color] })}
  >
    <Icon icon={icon} size={size === 'small' ? 'xs' : 'md'} />
  </Box>
);

export default StatusIcon;
